///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.multiselect.d.ts"/>
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InstallationAssetComponent } from '../Warranty/installationAsset.component';
import { InstallationComponent } from '../Warranty/installation.component';

var selectedOptionInUsersTab = new Array();
var selectedOptionInAssignedUsersTab = new Array();
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ProjectList/projects.html'
})

export class ProjectsComponent implements OnInit {
    constants: Constants;
    projectDetails: any = {};
    teamItems: any[];
    teams: any[];
    assignedTeams: any[];
    projectTypeItems: any = [];
    drpProjectType: any = "";
    projectStageItems: any = [];
    customers: any = [];
    drpCustomer: any = "";
    userDetail: any;
    selfuser: boolean = true;
    addEditProject: any = { Customer_Id: "", OwnerTeam_Id: "", Project_Type: "", AssignedTeam_Id: "0" };
    addEditProjectFormActive: any = true;
    projectUpdateTabFormActive: any = true;
    projectUpdateTabDetails: any = {};
    updateProject: any = { 'projectStage': "", 'projectStartDate': moment().format('DD/MM/YYYY'), 'projectComment': "","TransferToSalesPRO":false };
    projectTaskGroup: any = [];
    projectEstimateTabFormActive: any = true;
    projectEstimateTaskGroup: any = [];
    usersSelectAll: boolean = false;
    users: any = [];
    Modules: any = [];
    usersFiltered: any = [];
    teamAssigned: any = [];
    teammultiselect: any = [];
    assignedTeammultiselect: any = [];
    multiselectactive = true;
    public usersTeamAssigned: any = [];
    public assignedTeamUserData: any = [];
    objUsersTeam: any = [];
    addEditCommercial: any = { 'addEditCommercialValueCurrency': "", 'addEditCommercialTransferPriceCurrency': "", 'addEditCommercialYear': moment(new Date()).format('YYYY'), 'IsHourlyRate': false };
    addEditCommercialFormActive: any = true;
    projectFinancialItems: any = [];
    currencies: any = [];
    IsCommercialEdit: any = 0;
    projectLocationList: any = [];
    projectHistoryList: any = [];
    projectAnalysisList: any = [];
    projectUserCostList: any = [];
    public isAdd: boolean = true;
    active = true;
    public addLocationData: any = { addLocationState: "", addLocationCity: "" };
    //AddModule
    public addModuleData: any = { addModuleName: "" };
    public editModuleData: any = { addModuleName: "" };
    public ModulesList: any = [];
    projectModuleList: any = [];
    public editLocationData: any = { addLocationState: "", addLocationCity: "" };
    public deleteLocationObject: any = {};
    states: any = [];
    cities: any = [];
    public showLoader = false;
    SearchUsers: any = "";
    showUsertab: boolean = false;
    showOthertabs: boolean = false;
    fileTypeError: boolean = false;
    selectFileError: boolean = false;
    fileName: any;
    objTotalEstimate: any=0;
    public isAddEditProjectFormSubmitted: boolean = false;
    public isFormSubmitted: boolean = false;
    isTeamExisted: boolean = false;
    calculateEstimate: any;
    totalEstHrs: any = 0;
    totalPlanned: any = 0;
    totalActual: any = 0;
    totalUsed: any = 0;
    totalReported: any = 0;
    totalVariance: any = 0;
    greater: boolean;
    isCurrenySelected: boolean;
    completion: number;
    totalcompletion: number;
    isEditable: boolean = true;
    isEditableSharepoint: boolean = true; //by sj
    isAssignUser: boolean = false;
    isEditableForAdmin: boolean = true;
    CheckedUserList: any = [];
    isUpdateCost: boolean = true;
    showTransferValue: boolean = false;
    isRestrictedTeam: boolean = false;
    isProjectManagementTeam: boolean = false;
    showInstallationTab: boolean = true;
    IsValidProjectClosure: boolean= true;
    IRRefresh:any;

    @ViewChild('ProjectLocationCSV') csvFileInput: ElementRef;
    @ViewChild(InstallationAssetComponent) assetChild;
    @ViewChild(InstallationComponent) installationChild;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.route
            .params
            .subscribe(
                data => {
                    this.projectDetails.Project_Id = data["projectId"];
                    this.IsCommercialEdit = data["Com"];
                }
            );
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        console.log("TeamID:", this.userDetail.TeamID);
console.log("RoleID:", this.userDetail.RoleId);
        this.isProjectManagementTeam = this.userDetail.TeamID == 1028;
        console.log("isProjectManagementTeam:", this.isProjectManagementTeam);
        this.isRestrictedTeam = this.userDetail.TeamID == 1028;
        console.log("isRestrictedTeam:", this.isRestrictedTeam);
        if (this.projectDetails.Project_Id != 0) {
            this.getProjectList(true);
        }
        this.addEditProject.OwnerTeam_Id = "";
        this.addEditProject.AssignedTeam_Id = "";
        
    }

    ngOnInit() {
        this.bindDropdownsData();
        if (this.projectDetails.Project_Id != 0) {
            this.getUsers();
            this.getProjectEstimateTabDetails();
            this.GetProjectAnalysis();
            this.getProjectUpdateTabDetails();
            this.GetEstimate();
            this.GetProjectLocation();
            this.GetProjectFinancial();
            this.GetProjectModule();
        }
        else {
            this.getTeamAssignedToProject();
        }
    }

    ngAfterViewInit() {
        var dateNow = moment(new Date()).format('YYYY');
        $(".datemonthYear").datetimepicker({
            format: 'MM/YYYY'
        });
        $(".dateYear").datetimepicker({
            format: 'YYYY'
        });
        $(".time").datetimepicker({
            format: 'HH:mm'
        });
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

        setTimeout(() => {
            $('#teammultiselect').multiselect({
                enableFiltering: false,
                includeSelectAllOption: true,
                selectAllJustVisible: false,
                numberDisplayed: 1
            });

            $('#teammultiselect option').each(function () {
                if ($(this).attr('selected') == 'selected') {

                }
            });
        }, 1000);

        $("#teammultiselect").change(function () {
            var selectOption = $(this).find(":selected");
            var selectedValues = new Array();
            selectedOptionInUsersTab = new Array();
            selectOption.each(function (e) {
                selectedValues.push($(this).val());
                selectedOptionInUsersTab.push($(this).val());
            });
            $("#teammultiselect").val(selectedValues);
            $("#usersTeamAssigned").val(selectedValues);
            var selectPanel = $("#accordion").find(".panel.panel-default");
            selectPanel.each(function (e) {
                if (selectedOptionInUsersTab.includes($(this).find(".panel-collapse.collapse").attr("id"))) {
                    $(this).removeClass("hide");
                    $(this).addClass("show");
                }
                else {
                    $(this).removeClass("show");
                    $(this).addClass("hide");
                }
            });
        });
        //--------------------------Assigned Team multiselect---------------------------------------
        setTimeout(() => {
            $('#assignedTeammultiselect').multiselect({
                enableFiltering: false,
                includeSelectAllOption: true,
                selectAllJustVisible: false,
                numberDisplayed: 1
            });

            $('#assignedTeammultiselect option').each(function () {
                if ($(this).attr('selected') == 'selected') {

                }
            });
        }, 1000);

        $("#assignedTeammultiselect").change(function () {
            var selectOption = $(this).find(":selected");
            var selectedValues = new Array();
            selectedOptionInAssignedUsersTab = new Array();
            selectOption.each(function (e) {
                selectedValues.push($(this).val());
                selectedOptionInAssignedUsersTab.push($(this).val());
            });
            $("#assignedTeammultiselect").val(selectedValues);
            $("#assignedTeamUserData").val(selectedValues);
            var selectPanel = $("#accordion").find(".panel.panel-default");
            selectPanel.each(function (e) {
                if (selectedOptionInAssignedUsersTab.includes($(this).find(".panel-collapse.collapse").attr("id"))) {
                    $(this).removeClass("hide");
                    $(this).addClass("show");
                }
                else {
                    $(this).removeClass("show");
                    $(this).addClass("hide");
                }
            });
        });


    }


    ngAfterViewChecked() {
        $('#teammultiselect option').each(function () {
            $(this).html($(this).html().replace(/\s+/g, ' '));
        });

        $('#assignedTeammultiselect option').each(function () {
            $(this).html($(this).html().replace(/\s+/g, ' '));
        });
    }

    public AddLocationFormLoad() {
        $('#btnAddLocationForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    bindDropdownsData() {
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetAssignedTeam', { "TeamId": this.userDetail.TeamID, "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.teamItems = data["AssignedTeam"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter',
                    { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectType"] }).subscribe(
                        data => {
                            this.projectTypeItems = data["Parameter"];
                        },
                        err => {
                            this.showLoader = false;
                        },
                        () => {
                            this.showLoader = true;
                            this._httpService.ajaxPost('Common/GetParameter',
                                { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectStage"] }).subscribe(
                                    data => {
                                        this.projectStageItems = data["Parameter"];
                                        this.projectStageItems.sort(function (a, b) {
                                            if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1;
                                            if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1;
                                            return 0;
                                        })
                                    },
                                    err => {
                                        this.showLoader = false;
                                    },
                                    () => {
                                        this.showLoader = true;
                                        this._httpService.ajaxPost('Customer/GetCustomer', { "CustomerId": 0, "CountryId": 0, "CustomerStatus": true }).subscribe(
                                            data => {
                                                this.customers = data["CustomerList"];
                                                this.customers.sort(function (a, b) {
                                                    if (a.Customer_Name.toLowerCase() < b.Customer_Name.toLowerCase()) return -1;
                                                    if (a.Customer_Name.toLowerCase() > b.Customer_Name.toLowerCase()) return 1;
                                                    return 0;
                                                })
                                            },
                                            err => {
                                                this.showLoader = false;
                                            },
                                            () => {
                                                this.showLoader = true;
                                                this._httpService.ajaxPost('Common/GetState', null).subscribe(
                                                    data => {
                                                        this.states = data["States"];
                                                    },
                                                    err => {
                                                        this.showLoader = false;
                                                    },
                                                    () => {
                                                        this.showLoader = true;
                                                        this._httpService.ajaxPost('Common/GetCity', null).subscribe(
                                                            data => {
                                                                this.cities = data["Cities"];
                                                            },
                                                            err => {
                                                                this.showLoader = false;
                                                            },
                                                            () => {
                                                                this.showLoader = true;
                                                                this._httpService.ajaxPost('Common/GetParameter',
                                                                    { "ParameterTypeId": this.constants.enumParamterTypeName["Currency"] }).subscribe(
                                                                        data => {
                                                                            this.currencies = data["Parameter"];
                                                                        },
                                                                        err => {
                                                                            this.showLoader = false;
                                                                        },
                                                                        () => {
                                                                            this.showLoader = true;
                                                                            if (this.isTeamExisted || this.projectDetails.Project_Id == 0) {
                                                                                var teamUrl: string = 'Team/GetAssignedTeam';
                                                                                var teamParam: Object = { "TeamId": this.userDetail.TeamID, "UserId": this.userDetail.SiteUserId };
                                                                            } else {
                                                                                teamUrl = 'Team/GetTeam';
                                                                                teamParam = { "TeamId": 0 };
                                                                            }
                                                                            this._httpService.ajaxPost(teamUrl, teamParam).subscribe(
                                                                                data => {
                                                                                    if (this.isTeamExisted || this.projectDetails.Project_Id == 0) {
                                                                                        this.teams = data["AssignedTeam"];
                                                                                    }
                                                                                    else {
                                                                                        this.teams = data["Team"];
                                                                                    }

                                                                                },

                                                                                err => {
                                                                                    this.showLoader = false;
                                                                                },
                                                                                () => {
                                                                                    this.showLoader = false;

                                                                                });
                                                                        });
                                                            });
                                                    });
                                            });
                                    });
                        });
            });
        this.showLoader = false;
    }

    //project tab functions start

    getProjectList(flag: boolean) {
        this.selfuser = flag;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            TeamId = 0;
            // TeamId = this.userDetail.TeamID;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetProjectNew",
            { "ProjectId": this.projectDetails.Project_Id, "OwnerTeamId": TeamId, "AssignedTeam_Id": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
                data => {
                    this.projectDetails = data["ProjectList"][0];
                    let objItem: any = {};
                    objItem = JSON.parse(JSON.stringify(this.projectDetails));
                    this.addEditProject.Project_Id = objItem.Project_Id;
                    this.addEditProject.Project_Number = objItem.Project_Id;// objItem.ProjectCode;
                    this.addEditProject.Customer_Id = objItem.Customer_Id;
                    this.addEditProject.OwnerTeam_Id = objItem.OwnerTeam_Id;
                    this.addEditProject.AssignedTeamList = objItem.AssignedTeamList;
                    this.addEditProject.Project_Title = objItem.Project_Title;
                    this.addEditProject.Project_Type = objItem.Project_Type;
                    this.addEditProject.Project_Detail = objItem.Project_Detail;
                    this.addEditProject.Created_By = objItem.Created_By;
                    this.addEditProject.Sharepoint_Link = objItem.Sharepoint_Link;  //by sj
                    this.addEditProject.Updated_By = objItem.Updated_By;
                    this.addEditProject.Start_Date = objItem.Date;
                    this.addEditProject.End_Date = objItem.End_Date;
                    this.addEditProject.AssetCount = objItem.AssetCount;
                    this.getTeamAssignedToProject();
                    // by sj 
                    if (this.addEditProject.Sharepoint_Link) {
                        this.isEditableSharepoint = false;
                    } //by sj
                    if (this.addEditProject.AssignedTeamList != "" && this.addEditProject.AssignedTeamList != null && this.userDetail.RoleId != 0 && this.userDetail.RoleId != 1) {
                        if (this.addEditProject.OwnerTeam_Id == Number(this.userDetail.TeamID)) {
                            this.showTransferValue = true;
                        }
                        else {
                            this.showTransferValue = false;
                        }
                    }
                    else {
                        if (this.userDetail.RoleId != 0 && this.userDetail.RoleId != 1) {
                            if (this.addEditProject.OwnerTeam_Id == Number(this.userDetail.TeamID)) {
                                this.showTransferValue = true;
                            } else {
                                this.showTransferValue = false;
                            }
                        }
                        else {
                            this.showTransferValue = true;
                        }

                    }
                    if (this.addEditProject.Project_Type == 11) {
                        this.showInstallationTab = true;
                    }
                    else {
                        this.showInstallationTab = false;
                    }
                    this.assetChild.projectId = this.addEditProject.Project_Id;
                    this.installationChild.projectId = this.addEditProject.Project_Id;
                    this.assetChild.isProjectScreen = true;
                    this.installationChild.isProjectScreen = true;
                    this.assetChild.AssetCount = this.addEditProject.AssetCount;
                    this.assetChild.GetAssetList();
                    this.installationChild.customerId = this.addEditProject.Customer_Id;
                    this.installationChild.AssetCount = this.addEditProject.AssetCount;
                    this.installationChild.GetIRList();
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    var ownerTeamId = this.projectDetails.OwnerTeam_Id;
                    var teamId = this.userDetail.TeamID.split(",");
                    for (var i = 0; i < teamId.length; i++) {
                        if (teamId[i] == ownerTeamId) {
                            this.isTeamExisted = true;
                            break;
                        }
                    }
                    if (!this.isTeamExisted && this.userDetail.RoleId == 2) {
                        this.isEditable = false;
                    } else {
                        this.isEditable = true;
                    }

                    if (!this.isTeamExisted && this.userDetail.RoleId == 1) {
                        this.isEditableForAdmin = false;
                    } else {
                        this.isEditableForAdmin = true;
                    }

                    if (this.userDetail.RoleId == 0 || this.userDetail.RoleId == 1 || this.userDetail.RoleId == 2) {
                        this.isAssignUser = true;
                    }
                    else {
                        this.isAssignUser = false;
                    }

                    this.showLoader = false;
                }
            );
    }




    
private appendServicesToProjectDetail(services: any[]): void {
    const marker = '--- SalesPro Services ---';
    const currentDetail = this.addEditProject.Project_Detail || '';

    const markerIndex = currentDetail.indexOf(marker);
    const baseDetail = markerIndex >= 0
        ? currentDetail.substring(0, markerIndex).trimEnd()
        : currentDetail.trimEnd();

    const serviceText = (services || [])
        .map(s => `${s.ServiceName}: Qty ${s.Qty}`)
        .join('\n');

    this.addEditProject.Project_Detail = serviceText
        ? `${baseDetail}${baseDetail ? '\n\n' : ''}${marker}\n${serviceText}`
        : baseDetail;
}




    SetProjectId(){
        this.installationChild.isProjectScreen=true;
        this.installationChild.projectId = this.addEditProject.Project_Id;
        this.IRRefresh=Math.random();
    }

    addUpdateProjectTab(form: any) {
        this.isAddEditProjectFormSubmitted = true;
        if (form.form.valid && !this.greater) {
            if (this.projectDetails.Project_Id == 0) {
                this.addEditProject.Project_Id = 0;
                this.showUsertab = true
                this.addEditProject.Created_By = this.userDetail.SiteUserId;
            }
            else {
                this.addEditProject.Project_Id = this.projectDetails.Project_Id;
                this.addEditProject.Updated_By = this.userDetail.SiteUserId;
                this.addEditProject.Project_Number = this.projectDetails.Project_Id;
                this.showUsertab = false
            }

            let myDiv = document.getElementById('assignedTeamUserData');
            this.addEditProject.AssignedTeam_Id = myDiv["value"];


            this.showLoader = true;
            this._httpService.ajaxPost('Project/AddUpdateProject', this.addEditProject).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length >= 1) {

                        msg[0] = msg[0].toLowerCase();
                        if (msg[0] == "success") {
                            this.getUsers();
                            // this.IsCommercialEdit = 0;
                            this.getProjectList(true);
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else if (msg[0] == "warning") {
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else {
                            this._sharedService.ShowMessage(this.constants.globalError);
                        }
                    }
                    else {
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );
        } else {
            if (this.greater) {
                this._sharedService.ShowMessage("warning|ToDate should be greater than fromDate");
            }
        }
    }

    resetProjectTab() {
        this.addEditProject.Customer_Id = "";
        this.addEditProject.Project_Title = "";
        this.addEditProject.Project_Type = "";
        this.addEditProject.Project_Detail = "";
        this.addEditProject.OwnerTeam_Id = "";
        this.addEditProject.AssignedTeam_Id = "";
        this.newAddEditProjectTabForm();
    }
    newAddEditProjectTabForm() {
        this.addEditProjectFormActive = false;
        setTimeout(() => {
            this.addEditProjectFormActive = true;
        }, 0);
    }

    public getProjectUpdateTabDetails() {
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectPlan/GetProjectComments",
            { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {
                    if (data["ProjectComment"].length > 0) {
                        this.projectUpdateTabDetails = data["ProjectComment"][0];
                        let objItem: any = {};
                        objItem = JSON.parse(JSON.stringify(this.projectUpdateTabDetails));
                        this.updateProject.Project_Id = objItem.ProjectId;
                        this.updateProject.projectStage = objItem.Stage;
                        this.updateProject.projectStartDate = moment(objItem.Stage_Date).format('DD/MM/YYYY');
                        this.updateProject.projectComment = objItem.Comments;
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectPlan/GetProjectPlan",
            { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {
                    let objItem: any = {};
                    this.projectTaskGroup = [];
                    this.totalEstHrs = 0;
                    objItem = JSON.parse(JSON.stringify(data["ProjectPlan"]));
                    objItem.forEach(element => {
                        let objTaskItem: any = {};
                        objTaskItem.TaskName = element.TaskGroupName;
                        objTaskItem.TaskValue = element.Completion;
                        objTaskItem.TaskId = element.TaskGroupId;
                        objTaskItem.estimateHrs = element.EstimateHours;
                        this.totalEstHrs += objTaskItem.estimateHrs;
                        this.projectTaskGroup.push(objTaskItem);
                    });
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );
    }

    public async projectUpdateTab(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            let objItem: any = {};
            objItem.TaskGroupList = "";
            this.projectTaskGroup.forEach(element => {
                if (objItem.TaskGroupList != "") {
                    objItem.TaskGroupList += ",";
                }
                if (element.TaskValue == null)
                    element.TaskValue = 0;
                objItem.TaskGroupList += element.TaskId + "#" + element.TaskValue;
            });

            if(this.projectDetails.Project_Type==this.constants.projectType.HWInstallation ){
                await this.ValidateProjectClosure();
            }

            if (objItem.TaskGroupList == "") {
                this._sharedService.ShowMessage("Error|Task Group Should Mapped To Project Type");
            }
            else if(this.IsValidProjectClosure){
                objItem.ProjectPlan_Id = 0;
                objItem.Project_Id = this.projectDetails.Project_Id;
                objItem.Project_Status = 1;
                objItem.Start_Date = this.updateProject.projectStartDate;
                objItem.Comments = this.updateProject.projectComment;
                objItem.Stage = parseInt(this.updateProject.projectStage);
                objItem.Created_By = this.userDetail.SiteUserId;
                objItem.Updated_By = this.userDetail.SiteUserId;
                objItem.TransferToSalesPRO = this.updateProject.TransferToSalesPRO;
                this.showLoader = true;
                this._httpService.ajaxPost('ProjectPlan/UpdateProjectPlan', objItem).subscribe(
                    data => {
                        var msg = data["Status"].Message.split('|');
                        if (msg.length > 1) {
                            msg[0] = msg[0].toLowerCase();
                            this._sharedService.ShowMessage(data["Status"].Message);
                            // this._route.navigateByUrl("/projectList");

                        }
                        else {
                            this._sharedService.ShowMessage(msg);
                        }
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },

                    () => {
                        this.showLoader = false;
                    }
                );
            }
            else{
                this.showLoader = false;
                this._sharedService.ShowMessage("error| All the assets should be installed before closing the project.");
            }
        }
    }

    async ValidateProjectClosure(){
         //Validate all IR are completed
         this.IsValidProjectClosure=true;

        if(this.updateProject.projectStage==this.constants.PrjectStage.Closed)
        {
         await this._httpService.ajaxPost('InstallationRequest/ValidateProjectClosure', {"Project_Id" : this.projectDetails.Project_Id}).toPromise().then(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    if(msg[0]=="error"){
                        this.IsValidProjectClosure=false;
                    }
                }
               
            })
        }

    }

    public refreshProjectUpdateTab(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            let objItem: any = {};
            objItem.TaskGroupList = "";
            this.projectTaskGroup.forEach(element => {
                if (objItem.TaskGroupList != "") {
                    objItem.TaskGroupList += ",";
                }
                objItem.TaskGroupList += element.TaskId + "#" + element.TaskValue;
            });

            if (objItem.TaskGroupList == "") {
                this._sharedService.ShowMessage("Error|Task Group Should Mapped To Project Type");
            }
            else {
                objItem.ProjectPlan_Id = 0;
                objItem.Project_Id = this.projectDetails.Project_Id;
                objItem.Project_Status = 1;
                objItem.Start_Date = this.updateProject.projectStartDate;
                objItem.Comments = this.updateProject.projectComment;
                objItem.Stage = parseInt(this.updateProject.projectStage);
                objItem.Created_By = this.userDetail.SiteUserId;
                objItem.Updated_By = this.userDetail.SiteUserId;
                this.showLoader = true;
                this._httpService.ajaxPost('ProjectPlan/UpdateProjectPlan', objItem).subscribe(
                    data => {

                        var msg = data["Status"].Message.split('|');
                        if (msg.length > 1) {
                            msg[0] = msg[0].toLowerCase();
                            this._sharedService.ShowMessage(data["Status"].Message);
                            //  this._route.navigateByUrl("/projectList");
                            this.totalPlanned = 0;
                            this.totalActual = 0;
                            this.totalUsed = 0;
                            this.totalReported = 0;
                            this.totalVariance = 0;
                            this.GetProjectAnalysis();
                        }
                        else {
                            this._sharedService.ShowMessage(msg);
                        }
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },

                    () => {
                        this.showLoader = false;
                    }
                );
            }
        }
    }

    public resetProjectUpdateTab() {
        this.updateProject.projectStage = "";
        this.updateProject.projectStartDate = moment().format('DD/MM/YYYY');
        this.updateProject.projectComment = "";
        this.newProjectUpdateTabForm();
    }

    newProjectUpdateTabForm() {
        this.projectUpdateTabFormActive = false;
        setTimeout(() => {
            this.projectUpdateTabFormActive = true;
        }, 0);
    }

    //update tab functions end

    //users tab functions start

    public selectAllUsers() {
        this.usersFiltered.forEach(element => {
            element.IsChecked = this.usersSelectAll;
        });
    }

    public getUsers() {
        //get all user list (for active users set "UserStatus":"1")
        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetUsersTeam', {
            "IsActive": this.constants.enumUserStatus["Active"],
            "Role": null,
            "Site": null,
            "Team": this.userDetail.TeamID,
            "UserId": this.userDetail.SiteUserId
        }).subscribe(
            data => {
                this.users = data["Users"];
                this.getTeamAssigned();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }

    public getTeamAssignedToProject() {
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetTeam', { "TeamId": 0 }).subscribe(
            data => {
                this.assignedTeams = data["Team"];
                var TeamListArray = new Array();
                if (this.addEditProject.AssignedTeamList != "") {
                    TeamListArray = this.addEditProject.AssignedTeamList.split(',');
                }

                this.assignedTeams.forEach(element => {
                    element.Selected = false;
                    if (this.assignedTeams.length > 0) {
                        TeamListArray.forEach(item => {
                            if (item == element.Team_Id) {
                                element.Selected = true;
                                var length = this.assignedTeamUserData.length;
                                this.assignedTeamUserData[length] = element.Team_Id;
                            }
                        });
                    }
                });
                $("#assignedTeamUserData").val(this.assignedTeamUserData);
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            });
    }

    public getTeamAssigned() {
        if (this.projectDetails.Project_Id != 0) {
            this.showLoader = true;
            this._httpService.ajaxPost('TeamAssigned/GetTeamAssigned', { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {
                    this.teamAssigned = data["TeamAssignedList"][0];
                    var TeamListArray = new Array();
                    var UsersListArray = new Array();
                    if (this.teamAssigned != undefined) {
                        if (this.teamAssigned.TeamList != "") {
                            TeamListArray = this.teamAssigned.TeamList.split(',');
                        }
                        if (this.teamAssigned.UsersList != "") {
                            UsersListArray = this.teamAssigned.UsersList.split(',');
                        }
                    }

                    this.teamItems.forEach(element => {
                        element.Selected = false;
                        if (TeamListArray.length > 0) {
                            TeamListArray.forEach(item => {
                                if (item == element.Team_Id) {
                                    element.Selected = true;
                                    var length = this.usersTeamAssigned.length;
                                    this.usersTeamAssigned[length] = element.Team_Id;
                                }
                            });
                        }
                    });
                    $("#usersTeamAssigned").val(this.usersTeamAssigned);
                    var notCheckedList = new Array();
                    var checkedList = new Array();
                    this.users.forEach(element => {
                        element.IsChecked = false;
                        element.disabled = false;
                        console.log(this.projectDetails.Created_By);
                        if (UsersListArray.length > 0) {
                            UsersListArray.forEach(item => {
                                if (item == element.SiteUser_Id) {
                                    element.IsChecked = true;
                                }
                            });
                        }

                        if (element.SiteUser_Id == this.projectDetails.Created_By || element.IsDisableEdit == 1) {
                            element.disabled = true;
                        }

                        if (element.IsChecked == true) {
                            checkedList.push(element);
                        }
                        else {
                            notCheckedList.push(element);
                        }
                    });

                    this.CheckedUserList = checkedList;
                    this.users = [];
                    checkedList.forEach(element => {
                        this.users.push(element);
                    });
                    notCheckedList.forEach(element => {
                        this.users.push(element);
                    });

                    this.printconsole();
                    this.getCostForAssignedUser();
                    setTimeout(function () {
                        $('#teammultiselect').multiselect('refresh');
                    }, 0);
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }

            );
        }
        else {
            this.teamItems.forEach(element => {
                element.Selected = false;
            });
            this.users.forEach(element => {
                element.IsChecked = false;
            });
        }
    }

    public getCostForAssignedUser() {
        if (this.projectDetails.Project_Id != 0) {
            this.showLoader = true;
            this.projectUserCostList = [];
            this._httpService.ajaxPost('TeamAssigned/GetCostForAssignedUser', { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {
                    this.teamAssigned = data["TeamCostAssignedList"];
                    this.CheckedUserList.forEach(element => {
                        this.teamAssigned.forEach(element1 => {
                            if (element.SiteUser_Id == element1.SiteUser_Id) {
                                this.projectUserCostList.push(element1);
                            }

                        });
                    });
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }

            );
        }
    }

    public printconsole() {
        let myDiv = document.getElementById('usersTeamAssigned');
        this.usersTeamAssigned = myDiv["value"];

        this.usersTeamAssigned = this.usersTeamAssigned.split(",");
        this.usersFiltered = [];
        this.users.forEach((element) => {
            var elementAdded = false;
            for (var i = 0; i < this.usersTeamAssigned.length; i++) {
                if (element.TeamID != null && element.TeamID != '') {
                    this.objUsersTeam = element.TeamID.split(",");
                }
                for (var j = 0; j < this.objUsersTeam.length; j++) {
                    if (this.objUsersTeam[j] == this.usersTeamAssigned[i] && elementAdded == false) {
                        this.usersFiltered.push(element);
                        elementAdded = true;
                    }
                }
            }
        });

    }

    public addUpdateUsersTab() {
        let objItem: any = "";
        this.usersFiltered.forEach(element => {
            if (element.IsChecked == true) {
                if (objItem != "") {
                    objItem = objItem + ",";
                }
                objItem = objItem + element.SiteUser_Id;
            }
        });
        this.showLoader = true;
        this._httpService.ajaxPost('TeamAssigned/AddUpdateTeamAssigned', { "Project_Id": this.projectDetails.Project_Id, "UsersList": objItem, "CreatedBy": this.userDetail.SiteUserId, "UpdatedBy": this.userDetail.SiteUserId }).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    this.getTeamAssigned();
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(msg);
                }

            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }

    public resetUsersTab() {
        this.teamItems.forEach(element => {
            element.Selected = false;
        });
        this.users.forEach(element => {
            element.IsChecked = false;
        });

    }

    //users tab functions end

    //estimate tab functions start

    public GetEstimate() {

        this.objTotalEstimate = 0;

        this.projectEstimateTaskGroup.forEach(element => {
            console.log(element.EstimateHours);
            if (element.TaskValue == "") {
                element.TaskValue = 0;
            }
            this.objTotalEstimate += parseInt(element.TaskValue);
            console.log(this.objTotalEstimate);
        }
        );
        // this._httpService.ajaxPost("ProjectPlan/GetProjectPlanEstimate",
        //     { "ProjectId": this.projectDetails.Project_Id }).subscribe(
        //     data => {
        //         let objItem: any = {};
        //         //  this.projectEstimateTaskGroup = [];
        //         objItem = JSON.parse(JSON.stringify(data["ProjectPlanEstimate"]));
        //         //   this.calculateEstimate =objItem;
        //         objItem.forEach(element => {
        //             if (element.EstimateHours == "") {
        //                 element.EstimateHours = 0;
        //             }
        //             this.objTotalEstimate += parseInt(element.EstimateHours);
        //             console.log(this.objTotalEstimate);
        //         });
        //     });
    }

    public getProjectEstimateTabDetails() {
        this.showLoader = true;
        let objItem: any = {};
        this._httpService.ajaxPost("ProjectPlan/GetProjectPlanEstimate",
            { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {
                    objItem = JSON.parse(JSON.stringify(data["ProjectPlanEstimate"]));
                    //  this.calculateEstimate =objItem;              
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.projectEstimateTaskGroup = [];
                    objItem.forEach(element => {
                        let objTaskItem: any = {};
                        objTaskItem.TaskName = element.TaskGroupName;
                        objTaskItem.TaskValue = element.EstimateHours;
                        objTaskItem.TaskId = element.TaskGroupId;
                        this.projectEstimateTaskGroup.push(objTaskItem);
                    });
                    this.GetEstimate()
                    this.showLoader = false;
                }
            );
    }

    public projectEstimateTab(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            let objItem: any = {};
            objItem.TaskGroupList = "";
            this.projectEstimateTaskGroup.forEach(element => {
                if (objItem.TaskGroupList != "") {
                    objItem.TaskGroupList += ",";
                }
                objItem.TaskGroupList += element.TaskId + "#" + element.TaskValue;
            });

            if (objItem.TaskGroupList == "") {
                this._sharedService.ShowMessage("Error|Task Group Should Mapped To Project Type");
            }
            else {
                objItem.Project_Id = this.projectDetails.Project_Id;
                objItem.Created_By = this.userDetail.SiteUserId;
                objItem.Updated_By = this.userDetail.SiteUserId;
                this.showLoader = true;
                this._httpService.ajaxPost('ProjectPlan/UpdateProjectPlanEstimate', objItem).subscribe(
                    data => {

                        var msg = data["Status"].Message.split('|');
                        if (msg.length > 1) {
                            msg[0] = msg[0].toLowerCase();
                            this._sharedService.ShowMessage(data["Status"].Message);
                            this.getProjectEstimateTabDetails();
                        }
                        else {
                            this._sharedService.ShowMessage(msg);
                        }
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },

                    () => {
                        this.showLoader = false;
                    }
                );
            }
        }
    }

    public resetProjectEstimateTab() {
        this.projectEstimateTaskGroup.forEach(element => {
            element.TaskValue = "";
        });
        this.newProjectEstimateTabForm();
    }

    newProjectEstimateTabForm() {
        this.projectEstimateTabFormActive = false;
        setTimeout(() => {
            this.projectEstimateTabFormActive = true;
        }, 0);
    }

    //estimate tab functions end

    //commercial tab functions start

    GetProjectFinancial() {
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectFinancial/GetProjectFinancial",
            // { "Project_Id": this.projectDetails.Project_Id, "Team_Id": this.userDetail.TeamID, "Project_Type": 0, "ProjectYear": 0, "User_Id": this.userDetail.SiteUserId }).subscribe(
            { "Project_Id": this.projectDetails.Project_Id, "Team_Id": 0, "Project_Type": 0, "ProjectYear": 0, "User_Id": this.userDetail.SiteUserId }).subscribe(
                data => {
                    if (data["ProjectFinancialList"].length > 0) {
                        this.projectFinancialItems = data["ProjectFinancialList"][0];
                        let objItem: any = {};
                        objItem = JSON.parse(JSON.stringify(this.projectFinancialItems));
                        if (objItem.ProjectYear != null || objItem.ProjectYear != undefined) {
                            this.addEditCommercial.addEditCommercialYear = objItem.ProjectYear;
                        }
                        this.addEditCommercial.addEditCommercialValue = this.formatIndianNumber(objItem.Value);
                        if (objItem.ProjectValue_Currency != null || objItem.ProjectValue_Currency != undefined) {
                            this.addEditCommercial.addEditCommercialValueCurrency = objItem.ProjectValue_Currency;
                        }
                        this.addEditCommercial.addEditCommercialTransferPrice = this.formatIndianNumber(objItem.ProjectValue);
                        if (objItem.ProjectTP_Currency != null || objItem.ProjectTP_Currency != undefined) {
                            this.addEditCommercial.addEditCommercialTransferPriceCurrency = objItem.ProjectTP_Currency;
                        }
                        this.addEditCommercial.addEditCommercialCollected = this.formatIndianNumber(objItem.PaymentCollected);
                        this.addEditCommercial.ProjectCom_Id = objItem.ProjectCom_Id;
                        this.addEditCommercial.IsHourlyRate = objItem.IsHourlyRate;
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    newAddEditCommercialTabForm() {
        this.addEditCommercialFormActive = false;
        setTimeout(() => {
            this.addEditCommercialFormActive = true;
        }, 0);
    }

    formatIndianNumber(value: any): string {
        if (!value) {
            return '';
        }
        value = value.toString().replace(/,/g, '');
        return Number(value).toLocaleString('en-IN');
    }

    removeFormat(value: any): string {
        if (!value) {
            return '';
        }
        return value.toString().replace(/,/g, '');
    }

    //commercial tab functions end

    //history tab functions start

    public GetProjectHistory() {
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectHistory/GetProjectHistory",
            { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {
                    this.projectHistoryList = data["ProjectHistoryList"];
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    //history tab functions end

    //location tab functions start
    getFileErrors() {
        var files = this.csvFileInput.nativeElement.files;
        if (files.length != 0) {
            var startindex = files[0].name.length;
            var ext = files[0].name.substr(startindex - 4, 4);
            if (files[0].type == "application/vnd.ms-excel" && ext == '.csv') {
                this.selectFileError = false;
                this.fileTypeError = false;
            } else {
                this.fileTypeError = true;
                this._sharedService.ShowMessage("error|Plese Select *.csv file.")
            }
        } else {
            this.fileName = "";
            this.selectFileError = true;
        }
    }

    public UploadCSVProjectLocation() {
        this.showLoader = true;
        var files = this.csvFileInput.nativeElement.files;
        let itemsItem: any = {};
        this.fileTypeError = false;
        let jsonContent: any;
        if (files.length != 0) {
            if (files[0].type == "application/vnd.ms-excel" || files[0].type == "text/csv") {
                itemsItem.ItemIcon = files[0].name;
                this.fileTypeError = false;

                var fileName = files[0];
                if (!fileName) {
                    return;
                }
                var reader = new FileReader();
                reader.onload = file => {
                    var contents: any = file.target;
                    jsonContent = this.csvJSON(contents.result);
                    if (jsonContent.length != 0) {
                        jsonContent.forEach(element => {
                            element.ProjectLocationId = 0;
                            this.addEditLocation(element);
                            $('#uploadCsv').modal('hide');
                        });
                    }

                };
                reader.readAsText(fileName);
                this.showLoader = false;

            }
            else {
                this.fileTypeError = true;
                this.showLoader = false;
            }
        } else {
            this.selectFileError = true;
            this.showLoader = false;
        }

    }

    csvJSON(csv: any) {

        var lines = csv.split("\r\n");
        var result = [];
        var errorList = "";
        var headers = lines[0].split(",");
        var isError = false;

        if (headers[0] == "LocationName" && headers[1] == "ContactPerson" && headers[2] == "Designation" && headers[3] == "Email" && headers[4] == "ContactNumber"
            && headers[5] == "PinCode" && headers[6] == "Address" && headers.length == 7) {
            errorList += headers + ",ErrorInColumns";

            for (var i = 1; i < lines.length - 1; i++) {


                var currentline = this._sharedService.stringToColumns(lines[i]);
                var emptyLine = true;
                for (var k = 0; k < currentline.length; k++) {
                    if (currentline[k] === "") { }
                    else { emptyLine = false; }
                }
                if (emptyLine == false) {
                    errorList += "\r\n";
                    if (currentline.length == headers.length) {
                        let obj: any = {};
                        var emptyColumns = "";
                        var invalidColumns = "";
                        obj["ProjectId"] = this.projectDetails.Project_Id.toString();
                        for (var j = 0; j < headers.length; j++) {
                            var headername = headers[j];
                            obj[headername] = currentline[j];
                            if (currentline[j] == "") {
                                emptyColumns += headername + ", ";
                            }
                            if (headername == "LocationName" && /^[A-Za-z ]*$/.test(currentline[j]) == false) {
                                invalidColumns += headername + ", ";
                            }
                            if (headername == "ContactPerson" && /^[A-Za-z ]*$/.test(currentline[j]) == false) {
                                invalidColumns += headername + ", ";
                            }
                            if (headername == "Designation" && /^[A-Za-z ]*$/.test(currentline[j]) == false) {
                                invalidColumns += headername + ", ";
                            }
                            if (headername == "Email" && /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$/.test(currentline[j]) == false) {
                                invalidColumns += headername + ", ";
                            }
                            if (headername == "ContactNumber" && /^\d{10}$/.test(currentline[j]) == false) {
                                invalidColumns += headername + ", ";
                            }
                            if (headername == "PinCode" && /^\d{6}$/.test(currentline[j]) == false) {
                                invalidColumns += headername + ", ";
                            }
                            if (headername == "Address" && /^[A-Za-z0-9 @.,/&_-]*$/.test(currentline[j]) == false) {
                                invalidColumns += headername + ", ";
                            }
                        }
                        if (emptyColumns == "" && invalidColumns == "") {
                            result.push(obj);
                        }
                        else {
                            currentline[headers.length] = "";
                            if (emptyColumns != "") {
                                currentline[headers.length] += emptyColumns;
                            }
                            if (invalidColumns != "") {
                                currentline[headers.length] += invalidColumns;
                            }

                            currentline.forEach((element, index) => {

                                if (element.indexOf(',') >= 0) {
                                    currentline[index] = '"' + element + '"';
                                }

                            });
                            errorList += currentline.join(",");
                            isError = true;
                        }
                    }
                    else {
                        currentline[currentline.length] += " extra columns included";
                    }
                }
            }
            if (isError == true) {
                this.getErrorFile(errorList);
            }
        }
        else {
            this._sharedService.ShowMessage("warning|Invalid Format.")
        }

        return result; //JSON
    }

    getErrorFile(list: any) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        var blob = new Blob([list], { type: "text/csv" });
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "Error.csv";
        a.click();
    }

    getStaticFile() {
        this.showLoader = true;
        this._httpService.ajaxGet("Project/GetSampleCSV",
            null).subscribe(
                data => {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style.display = "none";
                    var blob = new Blob([data._body], { type: "text/csv" });
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = "Sample.csv";
                    a.click();

                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },


                () => {
                    this.showLoader = false;
                }
            );
    }

    public GetProjectLocation() {
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectLocation/GetProjectLocation",
            { "ProjectId": this.projectDetails.Project_Id, "ProjectLocationId": 0 }).subscribe(
                data => {
                    this.projectLocationList = data["ProjectLocationList"];
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }

            );
    }

    public CancelAddLocation() {
        this.addLocationData = { addLocationState: "", addLocationCity: "" };
        this.newForm();
        $('#addLocation').modal('hide');
        this.isAdd = true;
    }

    public CancelEditLocation() {
        this.editLocationData = { editLocationState: "", editLocationCity: "" };
        this.newForm();
        $('#editLocation').modal('hide');
        this.isAdd = true;
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    public AddLocation(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            let objItem: any = {};
            objItem.ProjectLocationId = 0;
            objItem.ProjectId = this.projectDetails.Project_Id;
            objItem.LocationName = this.addLocationData.addLocationName;
            objItem.ContactPerson = this.addLocationData.addLocationContactPerson;
            objItem.Designation = this.addLocationData.addLocationDesignation;
            objItem.Email = this.addLocationData.addLocationEmailId;
            objItem.ContactNumber = this.addLocationData.addLocationPhoneNumber;
            objItem.PinCode = this.addLocationData.addLocationPincode;
            objItem.Address = this.addLocationData.addLocationAddress;
            objItem.StateId = this.addLocationData.addLocationState;
            objItem.CityId = this.addLocationData.addLocationCity;
            objItem.Created_By = this.userDetail.SiteUserId;
            objItem.Updated_By = this.userDetail.SiteUserId;
            this.addEditLocation(objItem);
            $('#addLocation').modal('hide');
            this.addLocationData = { addLocationState: "", addLocationCity: "" };
            this.newForm();
            this.isAdd = true;
        }
    }

    EditLocation(item: any) {
        $('#btnEditLocationForm').trigger('click');
        this.isAdd = false;
        this.EditLocationChange(item.ProjectLocationId);
    }

    public EditLocationChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.projectLocationList.filter((location) => location.ProjectLocationId == itemId)[0]));
        this.editLocationData.ProjectId = objItem.ProjectId;
        this.editLocationData.ProjectLocationId = objItem.ProjectLocationId;
        this.editLocationData.editLocationName = objItem.LocationName;
        this.editLocationData.editLocationContactPerson = objItem.ContactPerson;
        this.editLocationData.editLocationDesignation = objItem.Designation;
        this.editLocationData.editLocationEmailId = objItem.Email;
        this.editLocationData.editLocationPhoneNumber = objItem.ContactNumber;
        this.editLocationData.editLocationPincode = objItem.PinCode;
        this.editLocationData.editLocationAddress = objItem.Address;
        this.editLocationData.editLocationState = objItem.StateId;
        this.editLocationData.editLocationCity = objItem.CityId;
    }

    public UpdateLocation(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            let objItem: any = {};
            objItem.ProjectId = this.editLocationData.ProjectId;
            objItem.ProjectLocationId = this.editLocationData.ProjectLocationId;
            objItem.LocationName = this.editLocationData.editLocationName;
            objItem.ContactPerson = this.editLocationData.editLocationContactPerson;
            objItem.Designation = this.editLocationData.editLocationDesignation;
            objItem.Email = this.editLocationData.editLocationEmailId;
            objItem.ContactNumber = this.editLocationData.editLocationPhoneNumber;
            objItem.PinCode = this.editLocationData.editLocationPincode;
            objItem.Address = this.editLocationData.editLocationAddress;
            objItem.StateId = this.editLocationData.editLocationState;
            objItem.CityId = this.editLocationData.editLocationCity;
            objItem.Created_By = this.userDetail.SiteUserId;
            objItem.Updated_By = this.userDetail.SiteUserId;
            this.addEditLocation(objItem);
            $('#editLocation').modal('hide');
            this.editLocationData = { editLocationState: "", editLocationCity: "" };
            this.newForm();
            this.isAdd = true;
        }
    }

    addEditLocation(objItem) {
        this.showLoader = true;
        objItem.Created_By = this.userDetail.SiteUserId;
        objItem.Updated_By = this.userDetail.SiteUserId;
        this._httpService.ajaxPost('ProjectLocation/AddUpdateProjectLocation', objItem).subscribe(
            data => {
                this._sharedService.ShowMessage(data["Status"].Message);
                this.GetProjectLocation();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }

    deleteLocation() {
        $('#deleteLocation').modal('hide');
        this.showLoader = true;
        this._httpService.ajaxPost('ProjectLocation/DeleteProjectLocation', { "ProjectLocationId": this.deleteLocationObject.ProjectLocationId }).subscribe(
            data => {
                this._sharedService.ShowMessage(data["Status"].Message);
                this.GetProjectLocation();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }

    deleteLocationChange(objItem) {
        this.deleteLocationObject = JSON.parse(JSON.stringify(objItem));
    }

    ExportProjectLocation() {
        ExportToExcel(this.projectLocationList, "Project Location",
            ["LocationName", "ContactPerson", "CityName", "ContactNumber", "Designation", "Email", "Address", "PinCode", "StateName"],
            ["Location Name", "Contact Person", "City Name", "Contact Number", "Designation", "Email", "Address", "PinCode", "State Name"]);

    }

    //location tab functions end

    chkDate() {
        var startDate = moment(this.addEditProject.Start_Date, "DD/MM/YYYY");
        var endDate = moment(this.addEditProject.End_Date, "DD/MM/YYYY");
        if (typeof startDate != null && typeof endDate != null) {
            if (startDate > endDate) {
                this._sharedService.ShowMessage("warning|End Date should be greater than Start Date");
                this.greater = true;
            } else {
                this.greater = false;
            }
        } else {
            this.greater = false;
        }
    }

    //Analysis tab functions start
    public GetProjectAnalysis() {
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectPlan/GetProjectAnalysis",
            { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {
                    this.projectAnalysisList = data["ProjectAnalysis"];
                    this.completion = 0;
                    this.projectAnalysisList.forEach(element => {
                        this.completion += element.SumOfCompletion;
                        this.totalPlanned += element.Planned;
                        this.totalActual += element.Actual;
                        this.totalReported += element.Variance;

                    });
                    if (this.totalPlanned != 0) {
                        this.totalUsed += (this.totalActual / this.totalPlanned) * 100;

                    }
                    let totalUsed: number = parseFloat(this.totalUsed.toFixed(2));
                    let totalcompletion: number = parseFloat(this.completion.toFixed(2));
                    this.totalcompletion = totalcompletion;
                    this.totalUsed = totalUsed;
                    let totalActual: number = parseFloat(this.totalActual.toFixed(2));
                    this.totalActual = Math.abs(totalActual);
                    let totalPlanned: number = parseFloat(this.totalPlanned.toFixed(2));
                    this.totalPlanned = Math.abs(totalPlanned);
                    let totalReported: number = parseFloat(this.completion.toFixed(2));
                    this.totalReported = Math.abs(totalReported);
                    this.totalVariance = totalUsed - this.totalReported;
                    let totalVariance: number = parseFloat(this.totalVariance.toFixed(2));
                    this.totalVariance = Math.abs(totalVariance);
                    console.log(totalUsed);
                    console.log(totalcompletion);

                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
    }
    //Analysis tab functions end
    //Module Tab
    public CancelAddModule() {
        this.addModuleData = { addModuleName: "" };
        this.newForm();
        $('#addModule').modal('hide');
        //this.isAdd = true;
    }

    public AddModule(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            let objItem: any = {};
            this.addModuleData.addModuleName = this.addModuleData.addModuleName[0].toUpperCase() + this.addModuleData.addModuleName.slice(1);
            objItem.ProjectId = this.projectDetails.Project_Id;
            objItem.ModuleName = this.addModuleData.addModuleName;
            //this.addModule();
            this.addEditModule(objItem);
            $('#addModule').modal('hide');
            this.addModuleData = { addModuleName: "" };
            this.newForm();

        }
    }
    public AddModuleFormLoad() {
        $('#btnAddModuleForm').trigger('click');
    }
    addModule() {
        this.showLoader = true;

        this._httpService.ajaxPost('ProjectModule/AddProjectModule').subscribe(
            data => {
                this._sharedService.ShowMessage(data["Status"].Message);
                this.GetProjectModule();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }
    addEditModule(objItem) {
        this.showLoader = true;

        this._httpService.ajaxPost('ProjectModule/AddUpdateProjectModule', objItem).subscribe(
            data => {

                if (objItem.ModuleName != "Main") {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.GetProjectModule();
                this.showLoader = false;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }
    public GetProjectModule() {
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectModule/GetProjectModule",
            { "ProjectId": this.projectDetails.Project_Id }).subscribe(
                data => {

                    this.projectModuleList = data["ProjectModuleList"];

                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }

            );
    }
    public UpdateModule(form: any) {
        // this._sharedService.ShowMessage("warning|Updating existing module  will impact all existing bugs");


        this.isFormSubmitted = true;



        if (form.form.valid) {
            let objItem: any = {};

            this.editModuleData.editModuleName = this.editModuleData.editModuleName[0].toUpperCase() + this.editModuleData.editModuleName.slice(1);
            objItem.ProjectId = this.editModuleData.ProjectId;
            objItem.ModuleId = this.editModuleData.ProjectModuleId;
            objItem.ModuleName = this.editModuleData.editModuleName;

            this.addEditModule(objItem);
            $('#editModule').modal('hide');
            this.editModuleData = { editModuleName: "" };
            this.newForm();
            //this.isAdd = true;
        }
    }

    public CancelEditModule() {
        this.editModuleData = { editModuleName: "" };
        this.newForm();
        $('#editModule').modal('hide');
        // this.isAdd = true;
    }

    EditModule(item: any) {
        this._sharedService.ShowMessage("warning|Updating existing module  will impact all existing bugs");

        $('#btnEditModuleForm').trigger('click');
        //this.isAdd = false;
        this.EditModuleChange(item);
    }

    public EditModuleChange(item) {
        let objItem: any = {};
        objItem = item;
        this.editModuleData.ProjectId = objItem.ProjectId;
        this.editModuleData.ProjectModuleId = objItem.ModuleId;
        this.editModuleData.editModuleName = objItem.ModuleName;

    }



    onStageChange(val) {
        if (val != this.constants.PrjectStage.Closed) {
            this.updateProject.TransferToSalesPRO = false
        }
        else{
            this.updateProject.TransferToSalesPRO = true;
        }
    }


}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ProjectList/projects.component.ts
 **/